import React from "react";
import { Col, Row } from "react-bootstrap";
import { SiNextdotjs, SiSolidity } from "react-icons/si";
import { FaRust } from "react-icons/fa";
import Javascript from "../../Assets/TechIcons/Javascript.svg";
import Node from "../../Assets/TechIcons/Node.svg";
import ReactIcon from "../../Assets/TechIcons/React.svg";
import Java from "../../Assets/TechIcons/Java.svg";
import Python from "../../Assets/TechIcons/Python.svg";
import Typescript from "../../Assets/TechIcons/Typescript.svg";
import Git from "../../Assets/TechIcons/Git.svg";
import Redis from "../../Assets/TechIcons/Redis.svg";
import Docker from "../../Assets/TechIcons/Docker.svg";
import SQL from "../../Assets/TechIcons/SQL.svg";
import Kubernates from "../../Assets/TechIcons/Kubernates.svg";
import Tailwind from "../../Assets/TechIcons/Tailwind.svg";
import Postman from "../../Assets/TechIcons/Postman.svg";
import AWS from "../../Assets/TechIcons/AWS.svg";
import Linux from "../../Assets/TechIcons/linux.svg";
import Fedora from "../../Assets/TechIcons/fedora.svg";
import Ubuntu from "../../Assets/TechIcons/ubuntu.svg";
import Jenkins from "../../Assets/TechIcons/jenkins.svg";
import Nginx from "../../Assets/TechIcons/nginx.svg";
import Helm from "../../Assets/TechIcons/helm.svg";
import Github from "../../Assets/TechIcons/github.svg";
import Prometheus from "../../Assets/TechIcons/prometheus.svg";
import Slack from "../../Assets/TechIcons/slack.svg";
import Grafana from "../../Assets/TechIcons/grafana.svg";
import Sonarqube from "../../Assets/TechIcons/sonarqube.svg";
import Terraform from "../../Assets/TechIcons/terraform.svg";
import Trivy from "../../Assets/TechIcons/trivy.svg";
import Django from "../../Assets/TechIcons/django.svg";
import GithubAction from "../../Assets/TechIcons/github actions.svg";



function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={4} md={2} className="tech-icons">
        <img src={Python} alt="Python" />
        <div className="tech-icons-text">Python</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Django} alt="Django" />
        <div className="tech-icons-text">Django</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Javascript} alt="javascript" />
        <div className="tech-icons-text">Javascript</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Node} alt="node" />
        <div className="tech-icons-text">Node.Js</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={ReactIcon} alt="react" />
        <div className="tech-icons-text">React.Js</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Git} alt="git" />
        <div className="tech-icons-text">Git</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Github} alt="github" />
        <div className="tech-icons-text">GitHub</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={GithubAction} alt="github-action" />
        <div className="tech-icons-text">GitHub Action</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Docker} alt="docker" />
        <div className="tech-icons-text">Docker</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Kubernates} alt="kubernetes" />
        <div className="tech-icons-text">Kubernetes</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={SQL} alt="SQL" />
        <div className="tech-icons-text">Postgresql</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Java} alt="haskell" />
        <div className="tech-icons-text">Java</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Tailwind} alt="tailwind" />
        <div className="tech-icons-text">Tailwind CSS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Postman} alt="Postman" />
        <div className="tech-icons-text">Postman</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={AWS} alt="aws" className="tech-icon-images" />
        <div className="tech-icons-text">AWS</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Nginx} alt="nginx" />
        <div className="tech-icons-text">Nginx</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Linux} alt="linux" />
        <div className="tech-icons-text">Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Jenkins} alt="jenkins" />
        <div className="tech-icons-text">Jenkins</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Sonarqube} alt="sonarqube" />
        <div className="tech-icons-text"></div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Trivy} alt="trivy" />
        <div className="tech-icons-text">Trivy</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Helm} alt="helm" />
        <div className="tech-icons-text">Helm</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Terraform} alt="terraform" />
        <div className="tech-icons-text">Terraform</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Prometheus} alt="prometheus" />
        <div className="tech-icons-text">Prometheus</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Grafana} alt="grafana" />
        <div className="tech-icons-text">Grafana</div>
      </Col>
    </Row>
  );
}

export default Techstack;
